import { useAtomValue } from 'jotai';
import { metricsTrackerAtom } from './metrics-atom';
export const useMetrics = () => {
  const metricsTracker = useAtomValue(metricsTrackerAtom);
  return metricsTracker;
};